import React from "react";
import styles from "./Classes.module.css";

/* IMAGES (local) */
import artImg from "../assets/Classes/art.jpeg";
import danceImg from "../assets/Classes/dance.jpg";
import shlokaImg from "../assets/Classes/shloka.jpg";
import bricksImg from "../assets/Classes/bricks.jpeg";
import chessImg from "../assets/Classes/chess.jpeg";

export default function Classes() {
  const goToContact = () => {
    window.location.href = "/contact";
  };

  return (
    <main className={styles.page}>

      {/* HERO */}
      <section className={styles.hero} onClick={goToContact}>
        <div className={styles.heroInner}>
          <h1>Our Evening Classes</h1>
          <p>
            Thoughtfully designed evening programs that nurture creativity,
            focus, confidence, and joyful learning for children aged{" "}
            <strong>3–10 years</strong>.
          </p>
        </div>
      </section>

      {/* BANNERS */}
      <section className={styles.banners}>

        <ClassBanner
          title="Art & Craft"
          description="A hands-on creative space where children explore colors, textures, and imagination through guided art activities."
          benefits={[
            "Boosts creativity & imagination",
            "Improves fine motor skills",
            "Encourages self-expression",
          ]}
          image={artImg}
          onClick={goToContact}
        />

        <ClassBanner
          title="Dance"
          description="Fun, energetic movement sessions that help children build rhythm, confidence, and body awareness."
          benefits={[
            "Improves coordination & balance",
            "Builds confidence",
            "Encourages joyful expression",
          ]}
          image={danceImg}
          reverse
          onClick={goToContact}
        />

        <ClassBanner
          title="Shloka Chanting"
          description="A calm and structured introduction to traditional chants that nurture focus, memory, and cultural awareness."
          benefits={[
            "Enhances concentration",
            "Improves memory",
            "Builds mindfulness & values",
          ]}
          image={shlokaImg}
          onClick={goToContact}
        />

        <ClassBanner
          title="Bricks4Kids"
          description="STEM-based learning through LEGO building that encourages logical thinking and problem-solving."
          benefits={[
            "Develops engineering thinking",
            "Enhances creativity",
            "Introduces STEM concepts playfully",
          ]}
          image={bricksImg}
          reverse
          onClick={goToContact}
        />

        <ClassBanner
          title="Chess"
          description="An engaging introduction to strategy, patience, and decision-making through the game of chess."
          benefits={[
            "Improves focus & patience",
            "Builds strategic thinking",
            "Encourages sportsmanship",
          ]}
          image={chessImg}
          onClick={goToContact}
        />

      </section>
    </main>
  );
}

/* ---------------------------------- */
/* BANNER COMPONENT */
/* ---------------------------------- */
function ClassBanner({ title, description, benefits, image, reverse, onClick }) {
  return (
    <article
      className={`${styles.banner} ${reverse ? styles.reverse : ""}`}
  onClick={onClick}
  onKeyDown={(e) => e.key === "Enter" && onClick()}
  role="button"
  tabIndex={0}
    >
      <div className={styles.imageWrap}>
        <img src={image} alt={title} />
      </div>

      <div className={styles.content}>
        <h2>{title}</h2>
        <p className={styles.desc}>{description}</p>

        <ul className={styles.benefits}>
          {benefits.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <span className={styles.cta}>Enquire →</span>
      </div>
    </article>
  );
}
